<template>
  <div class="teacher">
    <div class="teacher-list">
        <TeacherCard v-for="item in teacherList" :key="item.id" :item="item"/>
    </div>
  </div>
</template>
<script>
import TeacherCard from "./components/TeacherCard";
import { getCookie, group_sign } from '../../utils/tool'
export default {
  name: "teacher",
  components: { TeacherCard },
  data() {
    return {
      teacherList: [],
      topId:Number(getCookie('top_category_id')),
      account_id:Number(getCookie('account_id'))
    };
  },
  methods: {
    // 查询名师列表
    getTeacherList() {
      let that = this;
      var param = group_sign({limit_size:9999})
      this.$axios.post(this.$Api.apiGetTeacherList,param).then(
        res => {
          that.teacherList = res.data.result.list
        }
      ).catch(error => {console.log(error, ">>>>>>>>>");})
    },
  },
  beforeMount() {
    this.getTeacherList();
  }
};
</script>
<style lang="less" scoped>
.teacher {
  margin: 0 auto;
  padding-top: 50px;
  padding-bottom: 20px;
  width: 1180px;
  .teacher-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
